<div class="multisearch">

  <!-- Criteria Selection -->
  <div class="multisearch-grid" *ngFor="let row of rows; let i = index;">
    <nz-select nzShowSearch nzAllowClear [(ngModel)]="row.selectedCriteriaKey" [disabled]="row.isMandatory"
      (ngModelChange)="criteriaSelected(row.selectedCriteriaKey, i)" style="width: 100%;min-width: 250px;">
      <ng-container *ngFor="let criteria of SearchCriteria; let criteriaIndex = index;">
        <nz-option *ngIf="criteria.enable" [nzLabel]="criteria.keyDescription" [nzValue]="criteria.key"
          [nzHide]="isSearchCriteriaAlreadySelected(criteria.key)"></nz-option>
      </ng-container>
    </nz-select>

    <div class="pos-relative">
      <ng-container *ngIf="!checkWhetherExternalCriteria(row.selectedCriteriaKey); else preselectedMandatoryData">

        <!-- Input -->
        <nz-select nzShowSearch *ngIf="row.valueInputType === 'LOOKUP'" style="width: 100%" nzAllowClear
          nzPlaceHolder="{{'Choose'  | MMSTranslate}}" [(ngModel)]="row.selectedValue">
          <nz-option *ngFor="let item of row.lookup; let lookupIndex = index;" [nzValue]="item.lookupKey"
            [nzLabel]="item.lookupValue"></nz-option>
        </nz-select>
        <!-- DATE -->
        <nz-date-picker *ngIf="row.valueInputType === 'DATE'" nzShowTime [(ngModel)]="row.selectedValue" modelChanged
        [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>

        <nz-select nzShowSearch *ngIf="row.valueInputType == 'COMBOMULTISELECTCSV'" style="width: 100%" nzAllowClear
        [nzMode]="'multiple'" nzPlaceHolder="{{'Choose' | translate}}" [(ngModel)]="row.selectedValue">
        <nz-option *ngFor="let item of row.lookup; let lookupIndex = index;" [nzValue]="item.lookupKey"
          [nzLabel]="item.lookupValue"></nz-option>
        </nz-select>
      
        <!-- Input filed (resets and changes based on dropdown selection) -->
        <input *ngIf="row.valueInputType != 'LOOKUP' && row.valueInputType != 'DATE' && row.valueInputType != 'COMBOMULTISELECTCSV'" [disabled]="!row.valueInputType" type="text" nz-input
          placeholder="{{'Choose'  | MMSTranslate}}" [(ngModel)]="row.selectedValue"
          (ngModelChange)="modelChanged($event)" />

        <span *ngIf="row.isMandatory" class="ms-is-mandatory">
          *
        </span>

      </ng-container>

      <ng-template #preselectedMandatoryData>
        <nz-tag style="padding: 5px;width: 100%;" [nzColor]="'geekblue'">
          {{checkWhetherExternalCriteria(row.selectedCriteriaKey)? (checkWhetherExternalCriteria(row.selectedCriteriaKey).paramValue | technicalTranslate) : '-'}}
        </nz-tag>
      </ng-template>
      <!-- <i *ngIf="row.isMandatory" nz-icon nzType="info-circle" nzTheme="outline" nzTitle="Mandatory Search Criteria"
        nzPlacement="topCenter" nz-tooltip class=""></i> -->
    </div>
    <!-- Button Add row -->
    <button *ngIf="i === 0 && dropdownType != 'single'" nz-button nzType="dashed" (click)="addRow()">
      <i nz-icon nzType="plus" nzTheme="outline"></i>
    </button>
    <!-- Button Remove row -->
    <button *ngIf="i !== 0 && !row.isMandatory" nz-button nzType="dashed" nz-popconfirm
      nzOkText="{{'Remove'  | MMSTranslate}}"
      nzCancelText="{{'Cancel'  | MMSTranslate}}" (nzOnConfirm)="removeRow(i)">
      <i nz-icon nzType="delete" nzTheme="outline"></i>
    </button>

  </div>

  <!-- Search Button Pallette Section -->
  <div class="multisearch-grid">
    <!-- Button Add row (FIRST ROW WILL HAVE THIS) -->
    <div class="grid grid-2x grid-gap-10">
      <button (click)="searchAndEmitResult()" nz-button nzType="primary" [nzLoading]="searchAndEmitResultLoading">
        {{'Search' | MMSTranslate}}
      </button>
      <button (click)="resetResult()" nz-button nzType="default">
        Reset
      </button>
    </div>
    <div></div>
    <div></div>
  </div>
  <!-- Add New Row (Always show ?) -- >
  <div class="multisearch-add-row multisearch-grid">
      <div><span class="p-l-10">Add new filter</span></div>
      <div>&nbsp;</div>
      <button nz-button nzType="dashed" (click)="addRow()">
          <i nz-icon nzType="plus"  nzTheme="outline"></i>
      </button>
  </div>
  -->

</div>
